import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserPageTitle } from '../shared/constants/browser-page-title.enum';

import { SearchPage } from './search.page';
import { OrderExceptionsRouteGuard } from '@order/pages/order-exceptions/route-guards/order-exceptions-route.guard';

const routes: Routes = [
  {
    path: '',
    component: SearchPage,
    canDeactivate: [OrderExceptionsRouteGuard],
    data: { title: BrowserPageTitle.search },
  },
  {
    path: 'catalog',
    loadChildren: () =>
      import('./catalog/catalog.module').then(m => m.CatalogPageModule),
    data: { title: BrowserPageTitle.browseProducts },
  },
  {
    path: 'browse',
    loadChildren: () =>
      import('./browse/browse.module').then(m => m.BrowseModule),
    data: { title: BrowserPageTitle.browseProducts },
  },
  {
    path: 'compare',
    loadChildren: () =>
      import('./compare/product-compare.module').then(
        m => m.ProductCompareModule,
      ),
    data: { title: BrowserPageTitle.compare },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchPageRoutingModule {}
